module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_guatemala-28df8f8f.png";